const images = [
  { src: require("./ap-1.svg").default, alt: "approach-1" },
  { src: require("./ap-2.svg").default, alt: "approach-2" },
  { src: require("./ap-3.svg").default, alt: "approach-3" },
  { src: require("./ap-4.png"), alt: "approach-4" },
  { src: require("./ap-5.png"), alt: "approach-5" },
];

export default images;
